<div id="content-section">
  <ng-template #clientIntakeFormtemplate>
    <div class="modal-body">
      <app-client-intake-form
        (formModalCloseEvent)="onClientIntakeModalClose($event, true)"
        (editingClientIntakeStop)="clientIntakeFormEditMode = false;"
        [editingClientIntake]="clientIntakeFormEditMode"
        [preFillDataForEditMode]="clientIntake"
      >
      </app-client-intake-form>
    </div>
  </ng-template>
  <ng-template #clientIntakeShowtemplate>
    <div class="modal-body">
      <app-client-intake-show
        (showModalCloseEvent)="onClientIntakeModalClose($event, false)"
        (clientIntakeForEditingForm)="clientIntake = $event"
        (editingClientIntake)="openClientIntakeModal(clientIntakeFormtemplate, $event); clientIntakeFormEditMode = $event;"
        [editingClientIntakeStop]="clientIntakeFormEditMode"
        [clientIntakeId]="clientIntakeId"
      >
      </app-client-intake-show>
    </div>
  </ng-template>
  <div id="content-main" class="responsive-content-main" [style]="{ 'margin-right': sidebarMaximized ? '420px' : '320px' }">
    <div id="content-sidebar" [class]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [style]="{ width: sidebarMaximized ? '400px' : '300px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [class]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <button type="button" class="btn btn-primary btn-sm" style="width: 100%" (click)="openClientIntakeModal(clientIntakeFormtemplate, true)">
        <i class="fas fa-plus-circle"></i>
        &nbsp;Add New Client Intake
      </button>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination
          [boundaryLinks]="true" [totalItems]="count"
          (pageChanged)="pageChanged($event)" class="pagination-sm"
          [itemsPerPage]="searchParams.per_page" [maxSize]="3"
          previousText="&lsaquo;" nextText="&rsaquo;"
          firstText="&laquo;" lastText="&raquo;"
        ></pagination>
      </div>
      <div class="text-center pt-1">
        <span class="badge badge-primary">{{ count }} Client Intakes</span>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <div class="pull-right float-right">
            <button type="button" [disabled]="searching" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
          </div>
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
          <div class="form-group">
            <label>Intake ID</label>
            <input type="number" class="form-control form-control-sm" name="intake_id" [(ngModel)]="searchParams.intake_id" placeholder="Search by ID" />
          </div>
          <div class="form-group">
            <label>Client Name</label>
            <input type="text" class="form-control form-control-sm" name="client_name" [(ngModel)]="searchParams.client_name" />
          </div>
          <div class="form-group">
            <label>Matter</label>
            <app-matter-search
              id="matter"
              name="matter"
              [matterId]="searchParams.matter_id"
              (matter_id)="searchParams.matter_id = $event"
              [small_input]="true"
            ></app-matter-search>
          </div>
          <div class="form-group">
            <label>Date Range</label>
            <select class="form-control form-control-sm" name="date_range" [(ngModel)]="searchParams.date_range" (change)="selectDateRange()">
              <option *ngFor="let dateRange of searchOptions.date_ranges" [value]="dateRange.value">{{ dateRange.label }}</option>
            </select>
            <div class="form-row">
              <div class="col-6">
                <label>From</label>
                <app-datepicker [small_input]="true" (date_result)="searchParams.date_from = $event" [date]="searchParams.date_from" [isReadonly]="searchParams.date_range !== 'Custom Range'"></app-datepicker>
              </div>
              <div class="col-6">
                <label>To</label>
                <app-datepicker [small_input]="true" (date_result)="searchParams.date_to = $event" [date]="searchParams.date_to" [isReadonly]="searchParams.date_range !== 'Custom Range'"></app-datepicker>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Matter Type</label>
            <select class="form-control form-control-sm" name="matter_type_id" [(ngModel)]="searchParams.matter_type_id">
              <option *ngFor="let matterType of searchOptions.matter_types" [value]="matterType.value">{{ matterType.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Attorney</label>
            <select class="form-control form-control-sm" name="attorney_id" [(ngModel)]="searchParams.attorney_id">
              <option *ngFor="let attorney of searchOptions.attorneys" [value]="attorney.value">{{ attorney.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Opener</label>
            <select class="form-control form-control-sm" name="opener_id" [(ngModel)]="searchParams.opener_id">
              <option *ngFor="let opener of searchOptions.openers" [value]="opener.value">{{ opener.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Created by</label>
            <select class="form-control form-control-sm" name="created_by" [(ngModel)]="searchParams.created_by">
              <option *ngFor="let user of searchOptions.users" [value]="user.value">{{ user.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Updated by</label>
            <select class="form-control form-control-sm" name="updated_by" [(ngModel)]="searchParams.updated_by">
              <option *ngFor="let user of searchOptions.users" [value]="user.value">{{ user.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Referral Type</label>
            <select class="form-control form-control-sm" name="referral_type_id" [(ngModel)]="searchParams.referral_type_id">
              <option *ngFor="let referralType of searchOptions.referral_types" [value]="referralType.value">{{ referralType.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Priority</label>
            <select class="form-control form-control-sm" name="priority" [(ngModel)]="searchParams.priority">
              <option *ngFor="let priority of searchOptions.priorities" [value]="priority.value">{{ priority.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Deleted</label>
            <select class="form-control form-control-sm" name="deleted" [(ngModel)]="searchParams.deleted">
              <option *ngFor="let deletedOption of searchOptions.deleted" [value]="deletedOption.value">{{ deletedOption.label }}</option>
            </select>
          </div>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="show-intakes" [(ngModel)]="searchParams.show_intakes_with_matters">
            <label class="form-check-label" for="show-intakes">Show Intakes with Matters</label>
          </div>
          <div class="form-group">
            <label>Order by</label>
            <select class="form-control form-control-sm" name="order_by" [(ngModel)]="searchParams.order_by">
              <option *ngFor="let order_by of searchOptions.order_by" [value]="order_by.value">{{ order_by.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>In order of</label>
            <select class="form-control form-control-sm" name="order_of" [(ngModel)]="searchParams.order_of">
              <option *ngFor="let order_of of searchOptions.order_of" [value]="order_of.value">{{ order_of.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <button type="button" class="btn btn-primary btn-sm" style="width: 100%" (click)="searchParams.page = 1; search(null, true)" [disabled]="searching">
              Search
              <span *ngIf="searching">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Client Intakes</h2>
        <div class="table-responsive-md">
          <table class="table table-striped" *ngIf="count > 0">
            <thead>
              <tr>
                <th>Id</th>
                <th>Matter/Matter Type</th>
                <th>Contacts</th>
                <th>Attorney(s)</th>
                <th>Created by</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let clientIntake of clientIntakes">
                <td>
                  <a href="javascript:;" (click)="openClientIntakeModal(clientIntakeShowtemplate, false);clientIntakeId = clientIntake.id;">{{ clientIntake.id }}</a>
                  <br />
                  <span class="badge badge-info">{{ clientIntake.created_at }}</span>
                  <br *ngIf="clientIntake.locked" />
                  <button type="button" class="btn btn-warning btn-sm btn-block" *ngIf="clientIntake.locked" (click)="unlockClientIntake(clientIntake)">Unlock</button>
                </td>
                <td style="width: 35%">
                  <p class="bg-primary text-white px-1 mb-2">{{ clientIntake.matter_type_name }}</p>
                  <p class="bg-info text-white px-1" *ngIf="clientIntake.matter_number">
                    <a class="text-white" [routerLink]="'/matters/' + clientIntake.matter_id">
                      {{ clientIntake.matter_number }}
                    </a>
                    &nbsp;-&nbsp;
                    <span>{{ clientIntake.matter_name }}</span>
                  </p>
                  <p class="bg-warning px-1 mb-2" *ngIf="!clientIntake.matter_number">No matter defined</p>
                  <p *ngIf="clientIntake.appointment_scheduled_at">
                    <strong>New Client Appointment&nbsp;&nbsp;</strong>
                    at:&nbsp;
                    <span>{{ clientIntake.appointment_scheduled_at }}</span>
                    <br />
                    <span class="font-italic" style="font-size: 90%" [innerHTML]="clientIntake.appointment_scheduled_notes"></span>
                  </p>
                </td>
                <td>
                  <div class="bg-info text-white p-1 mb-1" *ngFor="let roleTypeContact of clientIntake.role_type_contacts">
                    <span>{{ roleTypeContact.contact_name }}</span>
                    <br />
                    <span *ngFor="let role of roleTypeContact.roles; let l = last">
                      <span
                        [ngClass]="{
                          'font-italic': role.is_client_contact
                        }"
                        class="font-weight-bold"
                      >
                      {{ role.role_type_name }}
                      </span>
                      <span *ngIf="!l">,&nbsp;</span>
                    </span>
                  </div>
                </td>
                <td>
                  <p *ngIf="clientIntake.attorney_name">
                    <strong>Active:</strong>
                    <br />
                    <span>{{ clientIntake.attorney_name }}</span>
                  </p>
                  <p *ngIf="clientIntake.opener_name">
                    <strong>Opener:</strong>
                    <br />
                    <span>{{ clientIntake.opener_name }}</span>
                  </p>
                </td>
                <td>
                  <p *ngIf="clientIntake.created_by_name">
                    <strong>Created By</strong>
                    <br />
                    <span>{{ clientIntake.created_by_name }}</span>
                  </p>
                  <p *ngIf="clientIntake.updated_by_name">
                    <strong>Updated By</strong>
                    <br />
                    <span>{{ clientIntake.updated_by_name }}</span>
                  </p>
                </td>
                <td>
                  <p *ngIf="clientIntake.client_name">
                    <strong>Client Name:&nbsp;</strong>
                    <span>{{ clientIntake.client_name }}</span>
                  </p>
                  <span *ngIf="clientIntake.not_ready_for_matter" class="badge badge-danger mr-1" data-toggle="tooltip" data-placement="left" title="Incomplete client contact">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 512"><path d="M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"/></svg>
                    </span>
                  </span>
                  <p class="text-white bg-success px-1 mr-1" *ngIf="clientIntake.priority">Priority client intake</p>
                  <span *ngIf="clientIntake.locked" class="badge badge-warning mr-1" data-toggle="tooltip" data-placement="left" title="This intake is locked">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 640 512" ><path d="M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"/></svg>
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="responsive-sidebar-toggle-btn" (click)="sidebarOpen = !sidebarOpen">
  <button type="button" class="btn" [class]="{ 'btn-primary': !sidebarOpen, 'btn-danger': sidebarOpen }">
    <i class="fas" [class]="{ 'fa-bars': !sidebarOpen, 'fa-times': sidebarOpen }"></i>
  </button>
</div>